import axios from 'axios';
import axiosConfig from './Config';


const CertificateChapter ={
    get: ({ params: {sub_type} }) => axiosConfig.get(`get-chapter-name/${sub_type}`),
    addNextSection: (body) => axiosConfig.post(`add-next-section`, body),
}

export default CertificateChapter;